// extracted by mini-css-extract-plugin
export default {"itemConatainer":"listitem_itemConatainer__o94gL","deviceimg":"listitem_deviceimg__oLh3U","devicename":"listitem_devicename__n7LVv"};